class DZModelSetting{

    id: any;

    /**
     * 系统设置主键
     */
    key = "";

    /**
     * 系统设置值
     */
    value = "";

    /**
     * 系统设置描述信息
     */
    msg = "";

    type = "";
}
export default DZModelSetting;
